import { Component, OnInit, Inject, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { IUipathJob } from 'app/rpa-bots/uipath/common/models/IUipathJob';
import { BZG_MODAL_DATA, BzgModalRef} from 'bz-genome-angular';

@Component({
  selector: 'bz-detail-confirm-jobs-modal',
  templateUrl: './detail-confirm-jobs-modal.component.html',
  styleUrls: ['./detail-confirm-jobs-modal.component.scss']
})
export class DetailConfirmJobsModalComponent implements OnInit {

  @Input() job: IUipathJob;
  @Input() inputArguments: any;

  constructor(private _modalRef: BzgModalRef,
    @Inject(BZG_MODAL_DATA) public initialData: IUipathJob) {
      if (initialData.InputArguments) {
        this.inputArguments = JSON.parse(initialData.InputArguments);
      }
      else {
        this.inputArguments = null;
      }
    }

  public form = new FormGroup({
    releaseName: new FormControl(''),
    inputArguments: new FormControl(''),
    idJob: new FormControl(''),
  });

  ngOnInit() {
    if (this.initialData) {
      this.form = new FormGroup({
        releaseName: new FormControl(this.initialData.ReleaseName),
        inputArguments: new FormControl(this.initialData.InputArguments),
        idJob: new FormControl(this.initialData.Id), // Cambiado de emidJobail a idJob
      });
    }
  }

  async retryJob(job: any) {
    this._modalRef.close(job);
  }
}
